import { clientApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_CLIENT_CREATE, PATH_CLIENT_INFO } from "@configs";
import { IClient } from "@interfaces";

import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";

import { CdicClientForm } from "src/Modules/clients/CdicForm";

export const PageCreateCdicClient = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const history = useHistory();
  const [client, setClient] = useState<IClient>();
  useEffect(() => {
    if (id) {
      fetchClient();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_CLIENT_INFO || ""}>{t("page.client_information")}</a>,
    },
    {
      title: <a href={PATH_CLIENT_CREATE || ""}>{t("page.add_client")}</a>,
    },
  ];
  const fetchClient = async () => {
    try {
      dispatch(setLoading(true));
      const res = await clientApi.cdicClient(id);
      setClient(res.data);
    } catch (err: any) {
      error(err.message);
      history.goBack();
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.add_client")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicClientForm client={client} />
      </StyledCreate>
    </>
  );
};
